export const TemplateVariableValidation = {
    maxLengthUpperBound: 30,
    maxVariableCount: 2,
    maxRatioPercent: 40,

    sumMaxLengths(maxLengths: number[]): number {
        if (!maxLengths || maxLengths.length === 0) {
            return 0;
        }
        return maxLengths.reduce((sum, ml) => sum + (ml || 0), 0);
    },

    getRawRatioPercent(totalMaxLength: number, textContentLength: number): number {
        if (textContentLength === 0) {
            return 0;
        }
        return (totalMaxLength / textContentLength) * 100;
    },

    getDisplayRatioPercent(totalMaxLength: number, textContentLength: number): number {
        return Math.round(this.getRawRatioPercent(totalMaxLength, textContentLength));
    },

    exceedsMaxRatio(totalMaxLength: number, textContentLength: number): boolean {
        if (textContentLength === 0 && totalMaxLength > 0) {
            return true;
        }
        return this.getRawRatioPercent(totalMaxLength, textContentLength) > this.maxRatioPercent;
    },

    hasEmptyExamples(examples: string[]): boolean {
        if (!examples || examples.length === 0) {
            return false;
        }
        return examples.some((value) => !value || value.trim() === '');
    },

    disallowedCharsByType: {
        'Numbers': /[^0-9\u0660-\u0669]/g,
        'Letters': /[^A-Za-z\u0621-\u063A\u0641-\u0652 ]/g,
        'Letters & Numbers': /[^A-Za-z0-9\u0621-\u063A\u0641-\u0652\u0660-\u0669 ]/g,
        'Link': /\s/g,
    } as { [type: string]: RegExp },

    linkPattern: /^(https?:\/\/)?[A-Za-z0-9-]+(\.[A-Za-z0-9-]+)+([\/?#]\S*)?$/i,

    sanitizeExampleForType(value: string, type: string): string {
        const pattern = this.disallowedCharsByType[type];
        if (!value || !pattern) {
            return value || '';
        }
        return value.replace(pattern, '');
    },

    isExampleValidForType(value: string, type: string): boolean {
        if (!value || !type) {
            return true;
        }
        if (type === 'Link') {
            return this.linkPattern.test(value);
        }
        return this.sanitizeExampleForType(value, type) === value;
    },
};
